import { SCHEDULES_GET, SCHEDULES_GET_SUCCESS, BRANCHES_GET, BRANCHES_GET_SUCCESS,
  DATES_GET, DATES_GET_SUCCESS, DATES_GET_BY_BRANCH, DATES_GET_BY_BRANCH_SUCCESS, CREATE_APPOINTMENT, 
  CREATE_APPOINTMENT_SUCCESS, API_ERROR } from "./actionTypes";

export const getSchedules = (payload, callback) => {
  return {
    type: SCHEDULES_GET,
    payload: { payload, callback },
  }
};

export const getSchedulesSuccess = payload => {
  return {
    type: SCHEDULES_GET_SUCCESS,
    payload: payload,
  }
};

export const getBranches = payload => {
  return {
    type: BRANCHES_GET,
    payload: payload,
  }
};

export const getBranchesSuccess = payload => {
  return {
    type: BRANCHES_GET_SUCCESS,
    payload: payload,
  }
};

export const getDates = (scheduleName, scheduleId, branchId, strDate, timezone) => {
  return {
    type: DATES_GET,
    payload: { scheduleName, scheduleId, branchId, strDate, timezone },
  }
};

export const getDatesSuccess = payload => {
  return {
    type: DATES_GET_SUCCESS,
    payload: payload,
  }
};

export const getDatesByBranch = (scheduleName, scheduleId, branchId, strDate, timezone) => {
  return {
    type: DATES_GET_BY_BRANCH,
    payload: { scheduleName, scheduleId, branchId, strDate, timezone },
  }
};

export const getDatesByBranchSuccess = payload => {
  return {
    type: DATES_GET_BY_BRANCH_SUCCESS,
    payload: payload,
  }
};

export const createAppointment = (appointment, callback) => {
  return {
    type: CREATE_APPOINTMENT,
    payload: { appointment, callback },
  }
};

export const createAppointmentSuccess = payload => {
  return {
    type: CREATE_APPOINTMENT_SUCCESS,
    payload: payload
  }
};

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
};
